export default "__VITE_ASSET__DVuu1bTJ__"